import { useMemo } from "react";
import { object, mixed } from "yup";
import { PROOF_FILE } from "consts/ecommerce";
import { fileSize, fileType } from "util/validators";
import { FormField } from "./types";

const useValidationSchema = () =>
    useMemo(() => (
        object().shape({
            [FormField.BankReferenceFileKey]: mixed()
                .required()
                .test('fileSize', 'File size is too large', fileSize(PROOF_FILE.maxSize))
                .test('fileType', 'Unsupported file format', fileType(PROOF_FILE.supportedFormats))
                .label('Bank Reference Document'),

            [FormField.CopyOfLicencesFileKey]: mixed()
                .required()
                .test('fileSize', 'File size is too large', fileSize(PROOF_FILE.maxSize))
                .test('fileType', 'Unsupported file format', fileType(PROOF_FILE.supportedFormats))
                .label('Copy of Licences Document'),

            [FormField.ProofOfDomainOwnershipFileKey]: mixed()
                .required()
                .test('fileSize', 'File size is too large', fileSize(PROOF_FILE.maxSize))
                .test('fileType', 'Unsupported file format', fileType(PROOF_FILE.supportedFormats))
                .label('Proof of Domain Ownership Document'),

            [FormField.StructureChartFileKey]: mixed()
                .required()
                .test('fileSize', 'File size is too large', fileSize(PROOF_FILE.maxSize))
                .test('fileType', 'Unsupported file format', fileType(PROOF_FILE.supportedFormats))
                .label('Structure Chart Document'),

            [FormField.CertificateOfIncorporationFileKey]: mixed()
                .required()
                .test('fileSize', 'File size is too large', fileSize(PROOF_FILE.maxSize))
                .test('fileType', 'Unsupported file format', fileType(PROOF_FILE.supportedFormats))
                .label('Certificate of Incorporation Document'),

            [FormField.MemorandumAndArticlesFileKey]: mixed()
                .required()
                .test('fileSize', 'File size is too large', fileSize(PROOF_FILE.maxSize))
                .test('fileType', 'Unsupported file format', fileType(PROOF_FILE.supportedFormats))
                .label('Memorandum and Articles Document'),

            [FormField.CompanyAccountBankStatementFileKey]: mixed()
                .required()
                .test('fileSize', 'File size is too large', fileSize(PROOF_FILE.maxSize))
                .test('fileType', 'Unsupported file format', fileType(PROOF_FILE.supportedFormats))
                .label('Company Account Bank Statement Document'),

            [FormField.CompanyFinancialStatementFileKey]: mixed()
                .required()
                .test('fileSize', 'File size is too large', fileSize(PROOF_FILE.maxSize))
                .test('fileType', 'Unsupported file format', fileType(PROOF_FILE.supportedFormats))
                .label('Company Financial Statement Document'),

            [FormField.PassportsOfShareholdersFileKey]: mixed()
                .required()
                .test('fileSize', 'File size is too large', fileSize(PROOF_FILE.maxSize))
                .test('fileType', 'Unsupported file format', fileType(PROOF_FILE.supportedFormats))
                .label('Passports of Shareholders Document'),

            [FormField.UtilityBillOfShareholdersFileKey]: mixed()
                .required()
                .test('fileSize', 'File size is too large', fileSize(PROOF_FILE.maxSize))
                .test('fileType', 'Unsupported file format', fileType(PROOF_FILE.supportedFormats))
                .label('Utility Bill of Shareholders Document'),

            [FormField.OfficialCompanyDocWithAuthorityFileKey]: mixed()
                .required()
                .test('fileSize', 'File size is too large', fileSize(PROOF_FILE.maxSize))
                .test('fileType', 'Unsupported file format', fileType(PROOF_FILE.supportedFormats))
                .label('Official Company Document with Authority Document')
        })
    ), []);

export default useValidationSchema;
